import styled from 'styled-components'

export const Wrapper = styled.div`
    transform: translateX(-108px) translateY(-53px);
`
